import React, { useEffect, useRef, useState } from 'react';

import Template from '../../component/Template.js';
import Api from '../../component/Api';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PDFModal from '../../component/PDFModal.js';
import 'datatables.net';
import Swal from 'sweetalert2';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import $ from 'jquery';


const ActionBtn = ({ onClick, title, borderColor, hoverBg, hoverColor, icon, baseColor }) => {
    const base = {
        background: '#fff',
        border: `1.5px solid ${borderColor}`,
        color: baseColor || borderColor,
        borderRadius: '7px',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        flexShrink: 0,
    };

    return (
        <button
            type="button"
            title={title}
            style={base}
            onMouseEnter={e => {
                e.currentTarget.style.background = hoverBg || borderColor;
                e.currentTarget.style.color = hoverColor || '#fff';
                e.currentTarget.style.transform = 'scale(1.1)';
            }}
            onMouseLeave={e => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.color = baseColor || borderColor;
                e.currentTarget.style.transform = 'scale(1)';
            }}
            onClick={onClick}
        >
            <i className={icon} style={{ fontSize: '15px', pointerEvents: 'none' }}></i>
        </button>
    );
};

export default function BOSExternalCreditList() {

    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/college/");
    }

    const tableRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const { http } = Api();

    // Data states
    const [studentData, setStudentData] = useState([]);
    const [getCourseStatisticsData, setCourseStatisticsData] = useState([]);
    const [getDisciplinesData, setDisciplinesData] = useState([]);

    // Filter states
    const [changedDisciplineData, setChangedDisciplineData] = useState({ value: 0, label: "All" });
    const [changedDisciplineId, setChangedDisciplineId] = useState(0);

    // Tab state
    const [activeTab, setActiveTab] = useState('forwarded_to_bos');

    // Selection states for bulk actions
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    // Custom datatable states
    const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' });
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setFilteredAndSortedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total_count, setTotal] = useState(0);

    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedCourseID, setSelectedCourse] = useState(false);
    const [getCourseData, setCourseData] = useState(null);

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
        }),
    };

    // Fetch disciplines when page loads
    useEffect(() => {
        const fetchDisciplines = async () => {

            try {
                const disciplineResponse = await http.get('/College/getBOSDisciplines');

                if (disciplineResponse.data.disciplines) {
                    setDisciplinesData(disciplineResponse.data.disciplines);
                }
            } catch (error) {
                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/admin/");
                    }, 5000);
                } else {
                    toast.error(error.response?.data?.message || "Error fetching disciplines");
                }
            }
        };

        fetchDisciplines();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Load on mount

    // Filter data based on active tab
    const getFilteredDataByTab = () => {
        return studentData.filter(student => {
            if (activeTab === 'bos_course_approved') {
                return student.verification_status === 'verified';
            } else if (activeTab === 'forwarded_to_bos') {
                return ['forwarded'].includes(student.verification_status);
            }
            return false;
        });
    };

    // Handle search and sorting
    useEffect(() => {
        const tabFilteredData = getFilteredDataByTab();

        const filtered = [...tabFilteredData].filter(student => {
            return (
                student.prn?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                student.studentname?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                student.apaar_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                student.course_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                student.discipline_name?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }).sort((a, b) => {
            if (!sortBy.column) return 0;

            if (sortBy.direction === 'asc') {
                return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
            } else {
                return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
            }
        });

        const itemsPerPage = 50;
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginatedData = filtered.slice(startIndex, startIndex + itemsPerPage);

        setFilteredAndSortedData(paginatedData);
        setTotalPages(Math.ceil(filtered.length / itemsPerPage));
        setTotal(filtered.length);
    }, [searchQuery, sortBy, studentData, currentPage, activeTab]);

    const handleDisciplineChange = (selectedOption) => {


        if (selectedOption) {
            setChangedDisciplineData(selectedOption);
            setChangedDisciplineId(selectedOption.value);
        } else {
            setChangedDisciplineData(null);
            setChangedDisciplineId(0);
        }
        // Clear student data when discipline changes
        // setStudentData([]);
        setSelectedStudents([]);
        setSelectAll(false);
    };

    const handleClearFields = () => {
        setChangedDisciplineData(null);
        setChangedDisciplineId(0);
        setStudentData([]);
        setSelectedStudents([]);
        setSelectAll(false);
    };

    // Fetch student list only when Go button is clicked
    const showStudentList = async () => {

        setLoading(true);
        setStudentData([]);
        setSelectedStudents([]);
        setSelectAll(false);

        try {
            const response = await http.get('/College/getStudentExternalCourseList', {
                params: {
                    discipline_id: changedDisciplineId,
                    page: currentPage,
                    limit: 50
                }
            });

            if (response.data.students && response.data.students.length > 0) {
                setStudentData(response.data.students);
                setCourseStatisticsData(response.data.counts);
            } else if (response.data.status_code === "ERR5") {
                setStudentData([]);
                setCourseStatisticsData([]);
                toast.error("Data not found");
            } else {
                setStudentData([]);
                setCourseStatisticsData([]);
            }

        } catch (error) {
            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                toast.error("Invalid Token");
                setTimeout(() => {
                    navigate("/admin/");
                }, 5000);
            } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.response?.data?.message || "Error fetching data");
            }
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        showStudentList();
    }, [currentPage]);


    useEffect(() => {
        const getBOSViewStudentExternalCourseList = async () => {
            try {
                const response = await http.get(`College/getBOSViewStudentExternalCourseList`, {
                    params: {
                        course_id: selectedCourseID
                    }
                });
                setCourseData(response.data.courseData);
            }
            catch (error) {
                setCourseData([]);
                selectedCourseID(false);
                if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/bos/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
                    toast.error("No data found");
                }
                else {
                    toast.error("Something went wrong");
                }
            }
        };
        if (selectedCourseID) {
            getBOSViewStudentExternalCourseList();
        }
    }, [selectedCourseID]);


    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const handleSort = (column) => {
        const newSortBy = {
            column,
            direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
        };
        setSortBy(newSortBy);
    };

    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc' ?
                <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> :
                <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
        }
        return <i className="fa fa-sort ml-1" aria-hidden="true"></i>;
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Selection handlers
    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);

        if (checked) {
            const allIds = filteredAndSortedData
                .filter(student => {
                    if (activeTab === 'forwarded_to_bos') {
                        return student.verification_status === 'forwarded';
                    }
                    return true;
                })
                .map(student => student.course_id);
            setSelectedStudents(allIds);
        } else {
            setSelectedStudents([]);
        }
    };

    // Auto-update selectAll when individual checkboxes change
    useEffect(() => {
        const eligibleIds = filteredAndSortedData
            .filter(student => {
                if (activeTab === 'forwarded_to_bos') {
                    return student.verification_status === 'forwarded';
                }
                return true;
            })
            .map(student => student.course_id);

        if (eligibleIds.length === 0) {
            setSelectAll(false);
            return;
        }

        const allEligibleSelected = eligibleIds.every(course_id => selectedStudents.includes(course_id));
        setSelectAll(allEligibleSelected);
    }, [selectedStudents, filteredAndSortedData, activeTab]);

    const handleSelectStudent = (courseId, applicationStatus) => {
        setSelectedStudents(prev => {
            if (prev.includes(courseId)) {
                return prev.filter(course_id => course_id !== courseId);
            } else {
                return [...prev, courseId];
            }
        });
    };

    // UNIFIED ACTION HANDLER - handles both single and bulk, forward and approve using updateCourseStatus
    const handleUpdateStatus = async (courseIds, status, actionName) => {
        const idsArray = Array.isArray(courseIds) ? courseIds : [courseIds];

        if (idsArray.length === 0) {
            toast.error("Please select at least one course");
            return;
        }

        const actionMapping = {
            'forwarded_to_bos': 'forward',
            'bos_course_approved': 'approve',
            'bos_course_rejected': 'reject'
        };

        const backendAction = actionMapping[status];

        // Config per action
        const swalConfig = {
            forwarded_to_bos: {
                title: 'Forward to BOS?',
                text: idsArray.length > 1
                    ? `Are you sure you want to forward ${idsArray.length} selected course(s) to BOS?`
                    : 'Are you sure you want to forward this course to BOS?',
                icon: 'question',
                confirmButtonText: 'Yes, Forward',
                confirmButtonColor: '#198754',
            },
            bos_course_approved: {
                title: 'Approve Course?',
                text: idsArray.length > 1
                    ? `Are you sure you want to approve ${idsArray.length} selected course(s)?`
                    : 'Are you sure you want to approve this course?',
                icon: 'question',
                confirmButtonText: 'Yes, Approve',
                confirmButtonColor: '#198754',
            },
            bos_course_rejected: {
                title: 'Reject Course?',
                text: idsArray.length > 1
                    ? `Are you sure you want to reject ${idsArray.length} selected course(s)?`
                    : 'Are you sure you want to reject this course?',
                icon: 'warning',
                confirmButtonText: 'Yes, Reject',
                confirmButtonColor: '#dc3545',

                html: `
                <div style="text-align: left; margin: 10px 20px 0 20px;">
                    <textarea id="rejectRemarks" class="swal2-textarea" placeholder="Enter remarks (required)..." 
                    style="width:100%; min-height:70px; font-size:13px; padding:8px 12px; box-sizing:border-box; margin:0;"></textarea>
                </div>
            `,
                preConfirm: () => {
                    const remarks = document.getElementById('rejectRemarks').value.trim();
                    if (!remarks) {
                        Swal.showValidationMessage('Remarks are required');
                        toast.error('Please enter rejection remarks');
                        return false;
                    }
                    return { remarks };
                }
            },
        };

        const config = swalConfig[status] || {
            title: 'Confirm Action?',
            text: `Are you sure you want to perform this action?`,
            icon: 'question',
            confirmButtonText: 'Yes, Proceed',
            confirmButtonColor: '#0d6efd',
        };

        const result = await Swal.fire({
            title: config.title,
            text: config.text,
            icon: config.icon,
            showCancelButton: true,
            confirmButtonColor: config.confirmButtonColor,
            cancelButtonColor: '#6c757d',
            confirmButtonText: config.confirmButtonText,
            cancelButtonText: 'Cancel',
            borderRadius: '10px',
            customClass: {
                popup: 'swal-custom-popup',
            },
            html: config.html,
            preConfirm: config.preConfirm
        });

        if (!result.isConfirmed) return;

        setLoading(true);

        try {
            const response = await http.post('/College/updateCourseStatus', {
                course_ids: idsArray,
                action: backendAction,
                remarks: status === 'bos_course_rejected' ? result.value?.remarks : null
            });

            if (response.data.status) {
                await Swal.fire({
                    title: 'Done!',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonColor: '#198754',
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                });
                setSelectedStudents([]);
                setSelectAll(false);
                await showStudentList();
            } else {
                Swal.fire({
                    title: 'Failed',
                    text: response.data.message,
                    icon: 'error',
                    confirmButtonColor: '#dc3545',
                });
                setLoading(false);
            }
        } catch (error) {
            if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                Swal.fire({
                    title: 'Session Expired',
                    text: 'Your session has expired. Please log in again.',
                    icon: 'error',
                    confirmButtonColor: '#dc3545',
                });
                setTimeout(() => navigate("/admin/"), 3000);
            } else {
                Swal.fire({
                    title: 'Error',
                    text: error.response?.data?.message || `Error processing ${actionName.toLowerCase()}`,
                    icon: 'error',
                    confirmButtonColor: '#dc3545',
                });
            }
            setLoading(false);
        }
    };


    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);
        setSelectedStudents([]);
        setSelectAll(false);
    };


    return (
        <>
            <ToastContainer />
            <Template>
                {loading ? (
                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                        <div className="containeranimate">
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="col-md-12">
                                        <div className="card-header">
                                            <div className="py-3 d-flex justify-content-between align-items-center">
                                                <h5>External Credit Approval</h5>
                                            </div>
                                        </div>
                                        <div className="card-body pdg">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label>Discipline <span className="errorclr">*</span></label>
                                                        <Select
                                                            maxMenuHeight={200}
                                                            menuPlacement="auto"
                                                            id="discipline_id"
                                                            name="discipline_id"
                                                            className="form"
                                                            styles={customStyles}
                                                            value={changedDisciplineData}
                                                            options={[
                                                                { value: 0, label: "All" },
                                                                ...(getDisciplinesData
                                                                    ? getDisciplinesData.map(discipline => ({
                                                                        value: discipline.id,
                                                                        label: discipline.discipline_name
                                                                    }))
                                                                    : [])
                                                            ]}
                                                            onChange={handleDisciplineChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="d-flex justify-content-end gap-2" style={{ marginTop: '28px' }}>
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary action-btn"
                                                                onClick={showStudentList}
                                                            >
                                                                Go
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary clear-btn btn-sm"
                                                                onClick={handleClearFields}
                                                            >
                                                                Clear
                                                            </button>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="col-xxl-12 col-xl-12 box-col-12">



                                                            <div className="container">
                                                                <div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>
                                                                    <div className="row justify-content-center">


                                                                        <div className="col-md-10 stat-out-bod">
                                                                            <h5 className="text-center mb-3">External Course Statistics Overview</h5>

                                                                            <table className="table-striped  table-bordered ex-table mb-10" ref={tableRef} id="dataTable" width="100%" style={{ textAlign: 'center', tableLayout: 'fixed' }}>
                                                                                <thead>

                                                                                    <tr style={{ height: '40px' }}>
                                                                                        <th>Pending</th>
                                                                                        <th>Approved</th>
                                                                                        <th>Over Due</th>


                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>

                                                                                        <td>{getCourseStatisticsData.forwarded}</td>
                                                                                        <td>{getCourseStatisticsData.verified}</td>
                                                                                        <td>{getCourseStatisticsData.expired}</td>

                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>




                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {studentData.length > 0 && (
                                                <div className="form theme-form">
                                                    <div className="custom-input">
                                                        <div className="card-body">
                                                            <div className="pdg1" style={{
                                                                border: '1px solid #dee2e6',
                                                                borderRadius: '10px',
                                                                overflow: 'hidden',
                                                                background: '#fff'
                                                            }}>
                                                                {/* Underline Tab Bar */}
                                                                <div style={{
                                                                    background: '#fff',
                                                                    borderBottom: '2px solid #dee2e6',
                                                                    padding: '0 16px',
                                                                    display: 'flex',
                                                                    gap: '0'
                                                                }}>
                                                                    <div
                                                                        onClick={() => handleTabChange('bos_course_approved')}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            padding: '14px 20px',
                                                                            fontSize: '13px',
                                                                            fontWeight: activeTab === 'bos_course_approved' ? '600' : '400',
                                                                            color: activeTab === 'bos_course_approved' ? 'var(--bs-primary)' : '#6c757d',
                                                                            borderBottom: activeTab === 'bos_course_approved' ? '2px solid var(--bs-primary)' : '2px solid transparent',
                                                                            marginBottom: '-2px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '8px',
                                                                            transition: 'all 0.15s ease',
                                                                            userSelect: 'none',
                                                                            whiteSpace: 'nowrap'
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-send-fill" style={{ fontSize: '12px' }}></i>
                                                                        Approved List
                                                                        <span style={{
                                                                            background: activeTab === 'bos_course_approved' ? '#e8f0fe' : '#f0f1f2',
                                                                            color: activeTab === 'bos_course_approved' ? 'var(--bs-primary)' : '#6c757d',
                                                                            borderRadius: '10px',
                                                                            padding: '1px 8px',
                                                                            fontSize: '11px',
                                                                            fontWeight: '500'
                                                                        }}>
                                                                            {studentData.filter(s => s.verification_status === 'verified').length}
                                                                        </span>
                                                                    </div>

                                                                    <div
                                                                        onClick={() => handleTabChange('forwarded_to_bos')}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            padding: '14px 20px',
                                                                            fontSize: '13px',
                                                                            fontWeight: activeTab === 'forwarded_to_bos' ? '600' : '400',
                                                                            color: activeTab === 'forwarded_to_bos' ? 'var(--bs-primary)' : '#6c757d',
                                                                            borderBottom: activeTab === 'forwarded_to_bos' ? '2px solid var(--bs-primary)' : '2px solid transparent',
                                                                            marginBottom: '-2px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '8px',
                                                                            transition: 'all 0.15s ease',
                                                                            userSelect: 'none',
                                                                            whiteSpace: 'nowrap'
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-building-check" style={{ fontSize: '12px' }}></i>
                                                                        Pending List
                                                                        <span style={{
                                                                            background: activeTab === 'forwarded_to_bos' ? '#e8f0fe' : '#f0f1f2',
                                                                            color: activeTab === 'forwarded_to_bos' ? 'var(--bs-primary)' : '#6c757d',
                                                                            borderRadius: '10px',
                                                                            padding: '1px 8px',
                                                                            fontSize: '11px',
                                                                            fontWeight: '500'
                                                                        }}>
                                                                            {studentData.filter(s => ['forwarded'].includes(s.verification_status)).length}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                {/* Table Content */}
                                                                <div style={{ padding: '16px', background: '#fff' }}>
                                                                    {/* Bulk action button */}


                                                                    <div className="table-responsive">
                                                                        <div className='row mt-2 mb-2'>
                                                                            <div className='col-md-6 wdt'>
                                                                                <p>
                                                                                    Showing {(currentPage - 1) * 50 + 1} - {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                                                                                </p>
                                                                            </div>
                                                                            <div className='col-md-6 wdt' align='right'>
                                                                                <input
                                                                                    type="text"
                                                                                    value={searchQuery}
                                                                                    onChange={handleSearchInputChange}
                                                                                    placeholder="Search..."
                                                                                    className='form-control'
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        {selectedStudents.length > 0 && (
                                                                            <div className="mb-3 d-flex gap-2 align-items-center flex-wrap">


                                                                                {activeTab === 'forwarded_to_bos' && (
                                                                                    <>
                                                                                        <button
                                                                                            type="button"
                                                                                            style={{
                                                                                                background: '#fff',
                                                                                                border: '1px solid #198754',
                                                                                                color: '#198754',
                                                                                                borderRadius: '6px',
                                                                                                padding: '5px 12px',
                                                                                                fontSize: '13px',
                                                                                                cursor: 'pointer',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                gap: '5px',
                                                                                                fontWeight: 500,
                                                                                                transition: 'all 0.15s ease'
                                                                                            }}
                                                                                            onMouseEnter={e => { e.currentTarget.style.background = '#198754'; e.currentTarget.style.color = '#fff'; }}
                                                                                            onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#198754'; }}
                                                                                            onClick={() => handleUpdateStatus(selectedStudents, 'bos_course_approved', 'Bulk approved')}
                                                                                        >
                                                                                            <i className="bi bi-check-circle-fill" style={{ fontSize: '12px' }}></i>
                                                                                            Approve Selected ({selectedStudents.length})
                                                                                        </button>

                                                                                        <button
                                                                                            type="button"
                                                                                            style={{
                                                                                                background: '#fff',
                                                                                                border: '1px solid #dc3545',
                                                                                                color: '#dc3545',
                                                                                                borderRadius: '6px',
                                                                                                padding: '5px 12px',
                                                                                                fontSize: '13px',
                                                                                                cursor: 'pointer',
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                                gap: '5px',
                                                                                                fontWeight: 500,
                                                                                                transition: 'all 0.15s ease'
                                                                                            }}
                                                                                            onMouseEnter={e => { e.currentTarget.style.background = '#dc3545'; e.currentTarget.style.color = '#fff'; }}
                                                                                            onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#dc3545'; }}
                                                                                            onClick={() => handleUpdateStatus(selectedStudents, 'bos_course_rejected', 'Bulk rejected')}
                                                                                        >
                                                                                            <i className="bi bi-x-circle-fill" style={{ fontSize: '12px' }}></i>
                                                                                            Reject Selected ({selectedStudents.length})
                                                                                        </button>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        )}

                                                                        <table className="display dataTable table-striped table-bordered ex-v-table" ref={tableRef}>
                                                                            <thead>
                                                                                <tr className="bg-primary">
                                                                                    <th style={{ width: '50px' }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={selectAll}
                                                                                            onChange={handleSelectAll}
                                                                                        />
                                                                                    </th>
                                                                                    <th>Sl No</th>

                                                                                    {activeTab === 'forwarded_to_bos' && (
                                                                                        <th onClick={() => handleSort('days_until_bos_expiry')} style={{ textAlign: "left", verticalAlign: "middle", cursor: 'pointer' }}>
                                                                                            Time Remaining For Approval {renderSortIcon('days_until_bos_expiry')}
                                                                                        </th>
                                                                                    )}

                                                                                    <th onClick={() => handleSort('course_code')} style={{ textAlign: "left", verticalAlign: "middle", cursor: 'pointer' }}>
                                                                                        Course Code {renderSortIcon('course_code')}
                                                                                    </th>
                                                                                    <th onClick={() => handleSort('course_name')} style={{ textAlign: "left", verticalAlign: "middle", cursor: 'pointer' }}>
                                                                                        Course Name {renderSortIcon('course_name')}
                                                                                    </th>
                                                                                    {/* <th onClick={() => handleSort('course_category_code')} style={{ textAlign: "left", verticalAlign: "middle", cursor: 'pointer' }}>
                                                                                        Course Category {renderSortIcon('course_category_code')}
                                                                                    </th> */}

                                                                                    {/* <th onClick={() => handleSort('course_discipline')} style={{ textAlign: "left", verticalAlign: "middle", cursor: 'pointer' }}>
                                                                                        Discipline {renderSortIcon('course_discipline')}
                                                                                    </th>
                                                                                    <th onClick={() => handleSort('acquired_credits')} style={{ textAlign: "center", verticalAlign: "middle", cursor: 'pointer' }}>
                                                                                        Credits {renderSortIcon('acquired_credits')}
                                                                                    </th> */}
                                                                                    <th style={{ textAlign: "center", verticalAlign: "middle" }}>Status</th>
                                                                                    <th style={{ width: '130px', textAlign: "center", verticalAlign: "middle" }}>Action</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {filteredAndSortedData && filteredAndSortedData.length > 0 ? (
                                                                                    filteredAndSortedData.map((item, index) => {
                                                                                        const serialNumber = (currentPage - 1) * 50 + index + 1;
                                                                                        const uniqueCourseId = item.course_id;
                                                                                        const isSelected = selectedStudents.includes(uniqueCourseId);
                                                                                        return (
                                                                                            <tr key={uniqueCourseId}>
                                                                                                <td>
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        checked={isSelected}
                                                                                                        onChange={() => handleSelectStudent(uniqueCourseId, item.verification_status)}

                                                                                                    />
                                                                                                </td>
                                                                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                                                    {serialNumber}
                                                                                                </td>


                                                                                                {activeTab === 'forwarded_to_bos' && (

                                                                                                    <td style={{ verticalAlign: "middle", fontSize: '13px' }}>
                                                                                                        {item.days_until_bos_expiry}
                                                                                                    </td>

                                                                                                )}
                                                                                                {/* Course Name */}

                                                                                                <td style={{ verticalAlign: "middle", fontSize: '13px' }}>
                                                                                                    {item.course_code ? `${item.course_code}` : ''}
                                                                                                </td>
                                                                                                <td style={{ verticalAlign: "middle", fontSize: '13px' }}>
                                                                                                    {item.course_name}
                                                                                                </td>
                                                                                                {/* Course Category */}
                                                                                                {/* <td style={{ verticalAlign: "middle", fontSize: '13px' }}>
                                                                                                    {item.course_category_code}
                                                                                                </td> */}
                                                                                                {/* Discipline */}
                                                                                                {/* <td style={{ verticalAlign: "middle", fontSize: '13px' }}>
                                                                                                    {item.course_discipline}
                                                                                                </td> */}

                                                                                                {/* Credits */}
                                                                                                {/* <td style={{ textAlign: "center", verticalAlign: "middle", fontWeight: 600, fontSize: '13px' }}>
                                                                                                    {item.credit}
                                                                                                </td> */}

                                                                                                {/* Status */}
                                                                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                                                    {(() => {
                                                                                                        const statusConfig = {
                                                                                                            forwarded: { label: 'BOS Approval Pending', bg: '#fd7e14' },
                                                                                                            verified: { label: 'BOS Approved', bg: 'green' }

                                                                                                        };
                                                                                                        const cfg = statusConfig[item.verification_status] || { label: item.verification_status_label || item.verification_status, bg: '#6c757d' };
                                                                                                        return (
                                                                                                            <span style={{
                                                                                                                background: cfg.bg,
                                                                                                                color: '#fff',
                                                                                                                borderRadius: '20px',
                                                                                                                padding: '3px 10px',
                                                                                                                fontSize: '11px',
                                                                                                                fontWeight: 600,
                                                                                                                whiteSpace: 'nowrap'
                                                                                                            }}>
                                                                                                                {cfg.label}
                                                                                                            </span>
                                                                                                        );
                                                                                                    })()}
                                                                                                </td>

                                                                                                {/* Action */}
                                                                                                <td style={{ width: '130px', textAlign: "center", verticalAlign: "middle" }}>
                                                                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', justifyContent: 'center', alignItems: 'center' }}>


                                                                                                        <ActionBtn
                                                                                                            onClick={() => {
                                                                                                                setSelectedCourse(item.course_id); // or your course object
                                                                                                                setShowViewModal(true);
                                                                                                            }}
                                                                                                            title="View"
                                                                                                            borderColor="#0d6efd"
                                                                                                            icon="bi bi-eye"
                                                                                                        />

                                                                                                        {/* Approve + Reject */}
                                                                                                        {activeTab === 'forwarded_to_bos' && (
                                                                                                            <>

                                                                                                                <ActionBtn
                                                                                                                    onClick={() => handleUpdateStatus(uniqueCourseId, 'bos_course_approved', 'BOS Course Approved')}
                                                                                                                    title="Approve"
                                                                                                                    borderColor="#198754"
                                                                                                                    icon="bi bi-check-lg"
                                                                                                                />

                                                                                                                <ActionBtn
                                                                                                                    onClick={() => handleUpdateStatus(uniqueCourseId, 'bos_course_rejected', 'BOS CourseRejected')}
                                                                                                                    title="Reject"
                                                                                                                    borderColor="#dc3545"
                                                                                                                    icon="bi bi-x-lg"
                                                                                                                />
                                                                                                            </>
                                                                                                        )}

                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })
                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={activeTab === 'forwarded_to_bos' ? 10 : 9} className="text-center py-3">No Data Found</td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    {/* Pagination */}
                                                                    {totalPages > 1 && (
                                                                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                                            <ul className="pagination justify-content-center mt-3">
                                                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                                    <span className="page-link pgn-clr" onClick={handlePreviousPage}>
                                                                                        <i className="bi bi-arrow-left-circle-fill"></i>
                                                                                    </span>
                                                                                </li>
                                                                                <li className="page-item">
                                                                                    <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                                                                </li>
                                                                                {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                                                {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                                                                    <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>
                                                                                            {pageNumber + 1}
                                                                                        </span>
                                                                                    </li>
                                                                                ))}
                                                                                {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                                                {totalPages > 1 && (
                                                                                    <li className="page-item">
                                                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                                                                    </li>
                                                                                )}
                                                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                                    <span className="page-link pgn-clr" onClick={handleNextPage}>
                                                                                        <i className="bi bi-arrow-right-circle-fill"></i>
                                                                                    </span>
                                                                                </li>
                                                                            </ul>
                                                                        </nav>
                                                                    )}
                                                                </div>



                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>



                                        <div className="bos_view">
                                            {showViewModal && getCourseData && (
                                                <div className="view-modal-overlay">
                                                    <div className="view-modal-dialog">

                                                        <div className="view-modal-content">

                                                            {/* HEADER */}
                                                            <div className="app-card-header">
                                                                <strong>
                                                                    <i className="fa fa-graduation-cap mr-2"></i>
                                                                    &nbsp;

                                                                    {getCourseData?.course_name}
                                                                    {getCourseData?.course_code ? ` - ${getCourseData.course_code}` : ''}
                                                                </strong>

                                                                <button
                                                                    className="modal-close-btn"
                                                                    onClick={() => setShowViewModal(false)}
                                                                >
                                                                    <i className="fa fa-times"></i>
                                                                </button>
                                                            </div>

                                                            {/* BODY */}
                                                            <div className="view-modal-body">

                                                                <div className="app-card">

                                                                    {/* COURSE DETAILS */}
                                                                    <div className="section-divider">Course Details</div>
                                                                    <div className="info-grid">
                                                                        <div className="info-item">
                                                                            <span className="info-label">Course Category</span>
                                                                            <span className="info-value">
                                                                                {getCourseData?.category_code || '—'}
                                                                            </span>
                                                                        </div>

                                                                        <div className="info-item">
                                                                            <span className="info-label">Course Discipline</span>
                                                                            <span className="info-value">
                                                                                {getCourseData?.discipline_name || 'N/A'}
                                                                            </span>
                                                                        </div>

                                                                        <div className="info-item">
                                                                            <span className="info-label">NHEQF Level</span>
                                                                            <span className="info-value">
                                                                                {getCourseData?.course_level || 'N/A'}
                                                                            </span>
                                                                        </div>

                                                                        <div className="info-item">
                                                                            <span className="info-label">Platform</span>
                                                                            <span className="info-value">
                                                                                {getCourseData?.platform || 'N/A'}
                                                                            </span>
                                                                        </div>

                                                                        <div className="info-item">
                                                                            <span className="info-label">Mode</span>
                                                                            <span className="info-value">
                                                                                {getCourseData?.mode || 'N/A'}
                                                                            </span>
                                                                        </div>


                                                                        <div className="info-item">
                                                                            <span className="info-label">Platform</span>
                                                                            <span className="info-value">
                                                                                {getCourseData?.platform || 'N/A'}
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    {/* GRADE & CREDITS */}
                                                                    <div className="section-divider">Grade & Credits</div>
                                                                    <div className="info-grid">

                                                                        <div className="info-item">
                                                                            <span className="info-label">Course Credit</span>
                                                                            <span className="info-value" style={{ fontWeight: 700 }}>
                                                                                {getCourseData?.credit ?? '—'}
                                                                            </span>
                                                                        </div>

                                                                        <div className="info-item">
                                                                            <span className="info-label">Grade Scale</span>
                                                                            <span className="info-value">
                                                                                {getCourseData?.grade_scale || 'N/A'}
                                                                            </span>
                                                                        </div>

                                                                        <div className="info-item">
                                                                            <span className="info-label">Verification Status</span>

                                                                            {(() => {
                                                                                const status = getCourseData?.verification_status;

                                                                                let bg = '#6c757d'; // default gray
                                                                                let label = 'N/A';

                                                                                switch (status) {
                                                                                    case 'entered':
                                                                                        bg = '#0d6efd'; // blue
                                                                                        label = 'Entered';
                                                                                        break;

                                                                                    case 'forwarded':
                                                                                        bg = '#fd7e14'; // yellow
                                                                                        label = 'BOS Approval Pending';
                                                                                        break;

                                                                                    case 'verified':
                                                                                        bg = '#198754'; // green
                                                                                        label = 'BOS Approved';
                                                                                        break;

                                                                                    case 'rejected':
                                                                                        bg = '#dc3545'; // red
                                                                                        label = 'Rejected';
                                                                                        break;

                                                                                    default:
                                                                                        bg = '#6c757d';
                                                                                        label = status || 'N/A';
                                                                                }

                                                                                return (
                                                                                    <span
                                                                                        className="badge-status"
                                                                                        style={{
                                                                                            background: bg,
                                                                                            color: '#fff',
                                                                                            display: 'inline-block',
                                                                                            width: 'fit-content'
                                                                                        }}
                                                                                    >
                                                                                        {label}
                                                                                    </span>
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                    </div>

                                                                    <div className="section-divider">Remarks</div>
                                                                    <div className="info-grid">

                                                                        <div className="info-item full-width">
                                                                            <span className="info-label">BOS Remarks</span>
                                                                            <textarea
                                                                                className="bos-textarea"
                                                                                value={getCourseData?.bos_remark || 'N/A'}
                                                                                readOnly
                                                                                rows={3}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            {/* FOOTER */}
                                                            <div className="view-modal-footer">
                                                                <button
                                                                    className="btn-close-modal"
                                                                    onClick={() => setShowViewModal(false)}
                                                                >
                                                                    Close
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>






                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Template>
        </>
    );
}